module.exports = __webpack_public_path__ + "~@/assets/img/6.4f403eb7.png";